module.exports = __webpack_public_path__ + "img/05.4e96341f.jpg";